<h2>Background Segmentation Test</h2>
<p>This component tests the BackgroundSegmentationService in isolation.</p>

<div style="display: flex; gap: 20px; margin-top: 20px">
  <div>
    <h3>Original Webcam Feed</h3>
    <video #videoEl width="320" height="240" autoplay playsinline muted style="border: 1px solid #ccc"></video>
  </div>
  <div>
    <h3>Segmentation Mask</h3>
    <canvas #maskCanvas width="320" height="240" style="border: 1px solid #ccc"></canvas>
    <p style="font-size: 0.8em">White areas are detected as foreground (person), black areas are background.</p>
  </div>
  <div>
    <h3>Composite Preview</h3>
    <canvas #compositeCanvas width="320" height="240" style="border: 1px solid #ccc"></canvas>
    <p style="font-size: 0.8em">Original video with mask overlay for visualization.</p>
  </div>
  <div>
    <h3>Pink Background Preview</h3>
    <canvas #pinkBgCanvas width="320" height="240" style="border: 1px solid #ccc"></canvas>
    <p style="font-size: 0.8em">Shows the person with a solid pink background.</p>
  </div>
</div>

<!-- Facial Landmarks Canvas -->
<div style="margin-top: 20px">
  <h3>Facial Landmarks</h3>
  <canvas #facialLandmarksCanvas width="320" height="240" style="border: 1px solid #ccc"></canvas>
  <p style="font-size: 0.8em">Facial landmarks detection visualization.</p>
</div>

<div style="margin-top: 20px">
  <div *ngIf="!modelLoaded" style="background-color: #fff3cd; padding: 10px; border-radius: 4px">
    <strong>Loading segmentation model...</strong> This may take a few seconds.
  </div>

  <div *ngIf="error" style="background-color: #f8d7da; padding: 10px; border-radius: 4px; margin-top: 10px">
    <strong>Error:</strong> {{ error }}
  </div>
</div>

<div style="margin-top: 20px">
  <button (click)="toggleMaskInversion()" style="margin-right: 10px; padding: 5px 10px">Toggle Mask Inversion</button>
  <button (click)="adjustThreshold(0.05)" style="margin-right: 10px; padding: 5px 10px">
    Increase Threshold (+0.05)
  </button>
  <button (click)="adjustThreshold(-0.05)" style="padding: 5px 10px">Decrease Threshold (-0.05)</button>
  <span style="margin-left: 10px">Current Threshold: {{ segmentationThreshold.toFixed(2) }}</span>
</div>

<!-- <div style="margin-top: 20px; display: flex; flex-wrap: wrap; gap: 15px">

  <div style="margin-right: 20px">
    <button (click)="toggleFlipHorizontal()" style="padding: 5px 10px; margin-right: 5px">
      {{ flipHorizontal ? 'Disable' : 'Enable' }} Flip Horizontal
    </button>
    <span>Status: {{ flipHorizontal ? 'Enabled' : 'Disabled' }}</span>
  </div>

  <div style="margin-right: 20px">
    <label for="resolution" style="margin-right: 5px">Output Resolution:</label>
    <select id="resolution" (change)="changeResolution($event)" style="padding: 5px">
      <option value="256x256" [selected]="outputWidth === 256">256x256 (Default)</option>
      <option value="320x240" [selected]="outputWidth === 320">320x240</option>
      <option value="512x512" [selected]="outputWidth === 512">512x512</option>
      <option value="640x480" [selected]="outputWidth === 640">640x480</option>
    </select>
  </div>

  <div style="margin-right: 20px">
    <label for="modelType" style="margin-right: 5px">Model Type:</label>
    <select id="modelType" (change)="changeModelType($event)" style="padding: 5px">
      <option value="general" [selected]="modelType === 'general'">General (Default)</option>
      <option value="landscape" [selected]="modelType === 'landscape'">Landscape</option>
    </select>
    <button (click)="reloadModel()" style="margin-left: 5px; padding: 5px 10px">Reload Model</button>
  </div>
</div> -->

<!-- Shader Threshold Control -->
<div style="margin-top: 20px">
  <label for="shaderThreshold" style="margin-right: 10px">Shader Threshold: {{ shaderThreshold.toFixed(2) }}</label>
  <button (click)="adjustShaderThreshold(0.05)" style="margin-right: 10px; padding: 5px 10px">
    Increase Shader Threshold (+0.05)
  </button>
  <button (click)="adjustShaderThreshold(-0.05)" style="padding: 5px 10px">Decrease Shader Threshold (-0.05)</button>
  <span style="margin-left: 10px; font-size: 0.8em">Controls how the mask is applied in the final composition.</span>
</div>

<!-- Facial Landmarks Controls -->
<div style="margin-top: 20px; border: 1px solid #ddd; padding: 15px; border-radius: 4px; background-color: #f9f9f9">
  <h3>Facial Landmark Controls</h3>

  <div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 10px">
    <div>
      <label style="margin-right: 10px">
        <input
          type="checkbox"
          [checked]="facialLandmarksEnabled"
          (change)="facialLandmarksEnabled = !facialLandmarksEnabled; toggleFacialLandmarks()"
        />
        Enable Facial Landmarks
      </label>
    </div>

    <div>
      <label for="effectType" style="margin-right: 5px">Effect Type:</label>
      <select id="effectType" [(ngModel)]="facialEffectType" style="padding: 5px">
        <option value="dots">Dots</option>
        <option value="mesh">Mesh</option>
        <option value="glasses">Glasses</option>
        <option value="hat">Hat</option>
        <option value="mustache">Mustache</option>
        <option value="googlyEyes">Googly Eyes</option>
        <option value="lighting">Lighting</option>
        <option value="puppet">Puppet Mode</option>
        <!-- Weather Effects -->
        <option value="rain">Rain</option>
        <option value="snow">Snow</option>
        <option value="bubbles">Bubbles</option>
        <option value="sparkles">Sparkles</option>
        <option value="particles">Floating Particles</option>
        <!-- half baked -->
        <!-- <option value="mask">Mask</option>
        <option value="cartoon">Cartoon</option> -->
      </select>
    </div>

    <div>
      <label for="effectColor" style="margin-right: 5px">Effect Color:</label>
      <input type="color" id="effectColor" [(ngModel)]="facialEffectColor" style="vertical-align: middle" />
    </div>

    <div>
      <label for="effectSize" style="margin-right: 5px">Effect Size:</label>
      <input
        type="range"
        id="effectSize"
        [(ngModel)]="facialEffectSize"
        min="1"
        max="10"
        style="vertical-align: middle"
      />
      <span style="margin-left: 5px">{{ facialEffectSize }}</span>
    </div>

    <div>
      <button (click)="reloadFacialLandmarksModel()" style="padding: 5px 10px">Reload Facial Model</button>
    </div>
  </div>
  <div style="margin-top: 10px">
    <button (click)="toggleFacialLandmarks()" style="padding: 5px 10px">
      {{ facialLandmarksEnabled ? 'Disable' : 'Enable' }} Facial Landmarks
    </button>
    <span style="margin-left: 10px">Status: {{ facialLandmarksEnabled ? 'Enabled' : 'Disabled' }}</span>
  </div>
</div>
